import { getEnvVariable } from './getEnvVariable'

// eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
const zaaksysteem = (): string => getEnvVariable('ZAAKSYSTEEM_URL', 'https://development.zaaksysteem.nl')
// eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call
const bezwaren = (): string => getEnvVariable('BEZWAREN_URL', 'https://bezwaren.dev.mijn.xxllnc.nl')

export const KENMERK_SYSTEEM = {
  XXLLNC_ZAKEN: 'xxllnc-zaken',
  XXLLNC_BEZWAREN: 'xxllnc-bezwaren',
} as const

interface CaseInterface {
    system: string | null | undefined
    number: string | null | undefined
}

export const getCaseUrl = ({ system, number }: CaseInterface): string | null => {
  if (!number || !system) return null

  if (system === KENMERK_SYSTEEM.XXLLNC_ZAKEN) {
    return `${zaaksysteem()}/intern/zaak/${number}`
  }

  if (system === KENMERK_SYSTEEM.XXLLNC_BEZWAREN) {
    return `${bezwaren()}/objection/${number}/show`
  }

  return null
}
